// frontend/src/pages/Services/Services.jsx
import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useTranslation } from 'react-i18next';
import profileImage from '../../assets/images/cropped_image.png';

const Services = () => {
  const { t, i18n } = useTranslation();
  const [markdownContent, setMarkdownContent] = useState('');

  // Fetch the markdown file whenever the language changes
  useEffect(() => {
    // Ensure we get 'en', 'de', or 'fr' (even if browser says 'en-US')
    const currentLang = i18n.language.split('-')[0]; 
    
    // Construct path: /instructions/service_en.md
    const filePath = `/instructions/service_${currentLang}.md`;

    fetch(filePath)
      .then((response) => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then((text) => setMarkdownContent(text))
      .catch((error) => {
        console.error('Error fetching markdown:', error);
        setMarkdownContent('Error loading content.');
      });
  }, [i18n.language]);

  return (
    <div className="min-h-screen bg-brand-dark text-gray-300">
      <div className="container mx-auto px-4 py-12 md:py-16 max-w-4xl">
        
        {/* Header Section */}
        <div className="mb-12">
          {/* Keep the Title in translation.json if it's short, or move to MD too */}
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 text-center">
            {t('services_page_title')}
          </h1>
          <img 
            src={profileImage} 
            alt="Dr. Miriam Grabenheinrich & Dr. Kader Metales" 
            className="w-80 h-80 object-cover mx-auto mb-4"
          />
          <p className="text-lg text-center">
            Dr. Miriam Grabenheinrich & Dr. Kader Metales
          </p>
        </div>

        {/* Dynamic Markdown Content */}
        <div className="markdown-container">
            <ReactMarkdown
                components={{
                    // Main Titles (h2)
                    h2: ({node, ...props}) => <h2 className="text-3xl font-bold text-white mb-6 leading-tight" {...props} />,
                    
                    // Section Titles (h3)
                    h3: ({node, ...props}) => <h3 className="text-2xl font-bold text-white mb-4 mt-12" {...props} />,
                    
                    // Sub-titles (h4)
                    h4: ({node, ...props}) => <h4 className="text-xl font-semibold text-white mb-3 mt-6" {...props} />,
                    
                    // Paragraphs
                    p: ({node, ...props}) => <p className="text-lg leading-relaxed mb-6" {...props} />,
                    
                    // Lists
                    ul: ({node, ...props}) => <ul className="list-disc list-inside space-y-3 mb-8" {...props} />,
                    ol: ({node, ...props}) => <ol className="list-decimal list-inside space-y-2 mb-8" {...props} />,
                    li: ({node, ...props}) => <li className="text-gray-300 ml-4" {...props} />,
                    
                    // Bold Text
                    strong: ({node, ...props}) => <strong className="text-white font-bold" {...props} />,
                    
                    // Horizontal Rule (Divider)
                    hr: ({node, ...props}) => <hr className="border-t-2 border-orange-500 my-12" {...props} />,
                }}
            >
                {markdownContent}
            </ReactMarkdown>
        </div>

        {/* Contact Footer */}
        <div className="mt-12 text-center">
            <hr className="border-t-2 border-orange-500 my-12" />
            <h3 className="text-2xl font-bold text-white mb-4">
                {t('more_info_title')}
            </h3>
            <a href="https://caaise.com" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-400 text-xl font-semibold transition-colors">
                www.caaise.com
            </a>
            <p className="mt-6 leading-relaxed max-w-2xl mx-auto">
                {t('contact_us_p1')}
            </p>
        </div>

      </div>
    </div>
  );
};

export default Services;
